 
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GenerateReceiptDetailsService {

  constructor(private http: HttpClient) {}

  async generateReceiptDetails(event_id,type_id) {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.genReceiptDetails}?event_id=${event_id}&type_id=${type_id}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}
